var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.155 133.709L121.125 124.258H102H82.875L48.8453 133.712C35.0466 137.543 25.5 150.105 25.5 164.423V197.624H102H178.5V164.423C178.5 150.105 168.953 137.543 155.155 133.709Z",
    fill: "#80D6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 178.5H57.375V197.625H51V178.5Z",
    fill: "#46BEE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.125 124.258H102H82.8749L76.5859 126.005C77.4625 139.274 88.5104 149.812 102 149.812C115.489 149.812 126.537 139.274 127.414 126.005L121.125 124.258Z",
    fill: "#46BEE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.125 101.945H82.875V124.258L82.8782 124.261C82.8782 124.277 82.875 124.293 82.875 124.312C82.875 134.875 91.4366 143.437 102 143.437C112.563 143.437 121.125 134.875 121.125 124.312C121.125 124.293 121.122 124.277 121.122 124.258H121.125V101.945Z",
    fill: "#FCB98B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 44.5703V76.4995C140.25 97.6231 123.124 114.75 102 114.75C80.8764 114.75 63.75 97.6231 63.75 76.4995V44.5703H140.25Z",
    fill: "#FFD3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 54.1875H142.459C146.338 54.1875 149.318 57.6236 148.77 61.4678L147.409 70.9761C146.96 74.1157 144.269 76.4458 141.098 76.4458H140.25V54.1875Z",
    fill: "#FFD3B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7494 54.1875H61.5405C57.6613 54.1875 54.681 57.6236 55.2292 61.4678L56.5903 70.9761C57.0397 74.1157 59.73 76.4458 62.9016 76.4458H63.7494V54.1875Z",
    fill: "#FFD3B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 76.4458L133.875 50.9458H102H70.125L63.75 76.4458V38.25C63.75 20.6454 78.0204 6.375 95.625 6.375H111.562C118.604 6.375 124.312 12.0838 124.312 19.125C133.113 19.125 140.25 26.2618 140.25 35.0625V76.4458Z",
    fill: "#6E83B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.938 31.875H162.562V9.5625H140.25V3.1875H168.938V31.875Z",
    fill: "#FFB0AA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4375 31.875H35.0625V3.1875H63.75V9.5625H41.4375V31.875Z",
    fill: "#FFB0AA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.938 124.312H140.25V117.938H162.562V95.625H168.938V124.312Z",
    fill: "#FFB0AA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.75 124.312H35.0625V95.625H41.4375V117.938H63.75V124.312Z",
    fill: "#FFB0AA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0625 60.5625H168.938V66.9375H35.0625V60.5625Z",
    fill: "#FFB0AA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75 197.625C183.354 197.625 197.625 183.354 197.625 165.75C197.625 148.146 183.354 133.875 165.75 133.875C148.146 133.875 133.875 148.146 133.875 165.75C133.875 183.354 148.146 197.625 165.75 197.625Z",
    fill: "#98CA69"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75 191.25C179.833 191.25 191.25 179.833 191.25 165.75C191.25 151.667 179.833 140.25 165.75 140.25C151.667 140.25 140.25 151.667 140.25 165.75C140.25 179.833 151.667 191.25 165.75 191.25Z",
    fill: "#EDEFF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.562 178.226L150.746 166.409L155.253 161.902L162.562 169.211L178.637 153.137L183.144 157.644L162.562 178.226Z",
    fill: "#98CA69"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.6370689b0914998d2cfea17438fd9faa.svg";
export { ForwardRef as ReactComponent };